import { Tooltip as Primitive } from 'radix-ui';
import { cn } from '../lib/cn';

export const TooltipProvider = Primitive.Provider;

export interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Secao 6.2: 500 ms antes de aparecer. */
  delayDuration?: number;
}

export function Tooltip({ content, children, side = 'top', delayDuration = 500 }: TooltipProps) {
  return (
    <Primitive.Root delayDuration={delayDuration}>
      <Primitive.Trigger asChild>{children}</Primitive.Trigger>
      <Primitive.Portal>
        <Primitive.Content
          side={side}
          sideOffset={6}
          className={cn(
            'z-50 rounded-wc-md bg-wc-dark px-2.5 py-1.5 text-[12px] font-medium text-white shadow-wc-md',
            'dark:bg-raised dark:text-primary dark:border dark:border-subtle',
            'select-none',
          )}
        >
          {content}
          <Primitive.Arrow className="fill-wc-dark dark:fill-[var(--surface-raised)]" />
        </Primitive.Content>
      </Primitive.Portal>
    </Primitive.Root>
  );
}
